import axios from "axios";
import environmentVariables from "../app/environmentVariables";

/**
 * Get all screens with coordinates and real-time status
 * @param {string} token - JWT authentication token
 * @returns {Promise} Axios response with screens data including latitude/longitude
 */
export function getScreensWithCoordinates(token) {
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    return axios.get(
        environmentVariables().REACT_APP_API_URL + '/getScreensWithCoordinates',
        config
    );
}

/**
 * Get real-time status and metrics for a specific screen
 * @param {string} token - JWT authentication token
 * @param {number} screenId - Screen ID
 * @returns {Promise} Axios response with real-time screen data
 */
export function getScreenRealTimeStatus(token, screenId) {
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    return axios.get(
        environmentVariables().REACT_APP_API_URL + `/getScreenRealTimeStatus?screenId=${screenId}`,
        config
    );
}

/**
 * Get all screens available for advertiser viewing
 * Used for selecting screens when creating ad campaigns
 * @param {string} token - JWT authentication token
 * @returns {Promise} Axios response with available screens
 */
export function getAvailableScreensForAdvertisers(token) {
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    return axios.get(
        environmentVariables().REACT_APP_API_URL + '/getAvailableScreensForAdvertisers',
        config
    );
}

/**
 * GET `/getScreenRealTimeStatus` — fleet snapshot for admin/advertiser maps.
 * Each screen: screenId, address, latitude, longitude, turnedOn, lastActive, isActive (recent heartbeat),
 * dimensions, brand, type, installedDate, locationDescription. No impression aggregates.
 * @param {string} token - JWT authentication token
 * @returns {Promise} Axios response `{ success, screens, totalScreens, activeScreens }`
 */
export function getAllScreensRealTimeStatus(token) {
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    return axios.get(
        environmentVariables().REACT_APP_API_URL + '/getScreenRealTimeStatus',
        config
    );
}
